import axios from "axios";
import authService from "./authService";
import {
  Distributor,
  DistributorRoleAction,
  SuccessPaginatedResponseMessage,
} from "../types";
import { SortBy } from "../common/components/Table/Table";

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_ROUTE = "/api/v1/user/distributor";

class DistributorService {
  static async getAllDistributors(
    pageNumber: number,
    rowsPerPage: number = 50,
    searchTerm: string = "",
    sortBy: SortBy | undefined
  ) {
    const res = await axios.post<
      SuccessPaginatedResponseMessage<{ distributors: Distributor[] }>
    >(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/distributors`,
      { pageNumber, rowsPerPage, searchTerm, sortBy },
      authService.getAuthHeader()
    );
    return res.data?.message;
  }

  static async updateDistributorRole(
    userId: string,
    action: DistributorRoleAction
  ) {
    const res = await axios.post(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/${action}`,
      { userId },
      authService.getAuthHeader()
    );
    return res.data;
  }

  static async addNewDistributorEmail(email: string) {
    const res = await axios.post(
      `${BACKEND_BASE_URL}${BASE_ROUTE}/preapproved/email`,
      { email },
      authService.getAuthHeader()
    );
    return res.data;
  }
}

export default DistributorService;
